import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="relative w-full bg-dark-800 py-24 md:py-32" data-id="element-17">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-18">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-19">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-20">
            <p className="text-gold text-sm font-semibold tracking-[0.3em] uppercase mb-4 font-body" data-id="element-21">
              About Us
            </p>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mb-8" data-id="element-22">
              Passion, Expertise &{' '}
              <span className="text-gold italic" data-id="element-23">Uncompromising Quality</span>
            </h2>
            <div className="space-y-5 text-white/60 text-base leading-relaxed font-body" data-id="element-24">
              <p data-id="element-25">
                At Vanscape, we don't just convert vehicles—we craft
                experiences. Based in the heart of Buckinghamshire and operating
                from Europe's largest Kia showroom, we've positioned ourselves
                at the forefront of PV5 campervan conversions.
              </p>
              <p data-id="element-26">
                Our team of experienced engineers shares a genuine passion for
                what we do. Through our professional trade partnership with the
                UK's leading conversion specialists, we source only the finest
                products and components. Combined with our own unique, in-house
                innovations, every conversion meets the highest standards of
                quality and craftsmanship.
              </p>
              <p data-id="element-27">
                Whether you're looking for a ready-to-go converted PV5, want
                your own vehicle transformed, or need accessories for life on
                the road—you've found the right place.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="relative" data-id="element-28">
            <div className="relative rounded-lg overflow-hidden aspect-[4/5]" data-id="element-29">
              <img src="https://cdn.magicpatterns.com/uploads/vMieofLD8Mk4jDGwFURZJL/WhatsApp_Image_2026-03-31_at_11.50.21_PM_(2).jpg" alt="Two Kia PV5 vehicles on display in Europe's largest Kia showroom" className="w-full h-full object-cover" data-id="element-30" />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-900/60 via-transparent to-transparent" data-id="element-31" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-dark-700 border border-white/5 rounded-lg p-6 shadow-2xl" data-id="element-32">
              <p className="text-gold font-display text-3xl font-bold" data-id="element-33">
                Europe's
              </p>
              <p className="text-white/80 text-sm font-body tracking-wide" data-id="element-34">
                Largest Kia Showroom
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}